import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Nav, Tab } from 'react-bootstrap-5';

import { connect } from 'react-redux';
import { setShowArchivedPlans } from './store/settings/actions';

import AddControl from 'components/add_control';
import Button from 'shared/button';
import CommissionPlanIcon from 'logos/commission-plan.svg';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import ManagedInput from 'components/form/managed_input';
import PlanModal from './form/modal';
import PlansTable from './table';
import Users from './users';

import './styles.scss';

export function CommissionPlanSettings({ plans, setShowArchivedPlans, showArchivedPlans }) {
  const [activeKey, setActiveKey] = useState('plans');
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="commission-plans-index d-flex flex-column gap-4">
      <h5>Commission Plans</h5>

      <Tab.Container activeKey={activeKey} id="plans" onSelect={setActiveKey}>
        <div>
          <div className="d-flex justify-content-between align-items-center">
            <Nav variant="pills">
              <Nav.Item>
                <Nav.Link eventKey="plans">Plans</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="users">Brokers</Nav.Link>
              </Nav.Item>
            </Nav>

            <div className="d-flex align-items-center gap-3">
              {!!plans.length && activeKey === 'plans' &&
                <ManagedInput
                  name="showArchivedPlans"
                  type="checkbox"
                  value={showArchivedPlans}
                  onValueChange={setShowArchivedPlans}
                >
                  Show Archived Plans
                </ManagedInput>
              }

              <AddControl name="add-plan" onClick={() => setShowModal(true)}>
                Add Commission Plan
              </AddControl>
            </div>
          </div>

          <Tab.Content>
            <Tab.Pane className="px-0" eventKey="plans">
              {plans.length ? <PlansTable/> :
                <Empty className="bg-white">
                  <Empty.Media>
                    <img src={CommissionPlanIcon} />
                  </Empty.Media>
                  <Empty.Content>
                    No commission plan(s) have been added yet
                  </Empty.Content>
                  <Empty.Actions>
                    <Button.Primary
                      label="Add Commission Plan"
                      onClick={() => setShowModal(true)}
                    />
                  </Empty.Actions>
                </Empty>
              }
            </Tab.Pane>
            <Tab.Pane className="px-0" eventKey="users">
              <Users/>
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>

      <PlanModal
        plan={{ name: '', tiers: [{ brokerSplit: 0 }], users: [], resetPeriod: 1 }}
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
}

CommissionPlanSettings.propTypes = {
  plans: PropTypes.array.isRequired,
  setShowArchivedPlans: PropTypes.func.isRequired,
  showArchivedPlans: PropTypes.bool,
};

const mapStateToProps = state => ({
  plans: state.plans,
  showArchivedPlans: state.settings.showArchivedPlans,
});

const mapDispatchToProps = {
  setShowArchivedPlans,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionPlanSettings);
